import { Fragment, createElement } from 'react';
import { useClientOnly } from '../hooks/useClientOnly';
export function ClientOnly(_ref) {
  let {
    children
  } = _ref;
  const hasMounted = useClientOnly();
  if (!hasMounted) {
    return null;
  }
  return /*#__PURE__*/createElement(Fragment, {
    children
  });
}